import api from './api';

const canonicalgroupService = {
  // Get all canonical groups with optional filters
  getAllCanonicalGroups: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.canonicalid) {
      params.append('canonicalid', filters.canonicalid);
    }

    if (filters.name) {
      params.append('name', filters.name);
    }

    if (filters.parent_id !== undefined) {
      params.append('parent_id', filters.parent_id);
    }

    const queryString = params.toString();
    const url = queryString ? `/admin/canonicalgroup?${queryString}` : '/admin/canonicalgroup';

    return api.get(url);
  },

  // Get a single canonical group by ID
  getCanonicalGroupById: async (id) => {
    return api.get(`/admin/canonicalgroup/${id}`);
  },

  // Create a new canonical group
  createCanonicalGroup: async (canonicalgroupData) => {
    return api.post('/admin/canonicalgroup', canonicalgroupData);
  },

  // Update an existing canonical group
  updateCanonicalGroup: async (id, canonicalgroupData) => {
    return api.put(`/admin/canonicalgroup/${id}`, canonicalgroupData);
  },

  // Delete a canonical group
  deleteCanonicalGroup: async (id) => {
    return api.delete(`/admin/canonicalgroup/${id}`);
  }
};

export default canonicalgroupService;
